import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InitialPage } from './initial.page';

const routes: Routes = [
  {
    path: '',
    component: InitialPage
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes), InitialPage]
})
export class InitialPageModule {}
